import { Flex, SimpleGrid } from "@chakra-ui/react";
import {
  OrgPublicProfileDto,
  OrganizationEntryDto,
} from "../../../../autogen/bff-api";
import { requireBooleanEnvVar } from "../../../../config";
import { AboutUs } from "../content-items/AboutUs";
import { Certificates } from "../content-items/Certificates";
import { ContactPersons } from "../content-items/ContactPersons";
import { Details } from "../content-items/Details";
import { LinkedEntries } from "../content-items/LinkedEntries";
import { Location } from "../content-items/Location";
import { Specialties } from "../content-items/Specialties";

interface InformationSectionProps {
  organization?: OrgPublicProfileDto;
  organizationEntry?: OrganizationEntryDto;
}

export const InformationSection = ({
  organization,
  organizationEntry,
}: InformationSectionProps) => {
  const showDummyData = requireBooleanEnvVar("VITE_ENABLE_DUMMY_COMPANY_PAGE");

  const orgData = organization || organizationEntry;

  if (!orgData) throw new Error("No organization data");

  return (
    <Flex
      flexDirection="column"
      width="full"
      maxWidth="full"
      overflow="hidden"
      columnGap={6}
    >
      <SimpleGrid
        width="full"
        flexWrap="wrap"
        overflowX="hidden"
        columns={{ base: 1, lg: 2 }}
        spacing="6"
        pb="6"
      >
        {organization && <AboutUs organization={organization} />}
        {organization && <Specialties organization={organization} />}
        <ContactPersons
          organization={organization}
          organizationEntry={organizationEntry}
        />
        {showDummyData && <Location />}
        {showDummyData && <Certificates />}
      </SimpleGrid>
      <Flex flexDirection="column" gap="6">
        {organization && organization.linkedEntries.length > 0 && (
          <LinkedEntries entries={organization.linkedEntries} />
        )}
        <Details
          organization={organization}
          organizationEntry={organizationEntry}
        />
      </Flex>
    </Flex>
  );
};
